import React from 'react';
import { Stack, Typography } from '@mui/material';
import TestTasksSelectableList from '../components/TestTasksSelectableList';
import PassTestTaskButton from '../components/PassTestTaskButton';

import { AvailableTestTaskWithPositionsData } from '../../../types';

import { Flex } from '../../../components';
import { HackerRankDescription } from '../components/HackerRankDescription';
import { useFeatureFlags } from '../../../hooks';
import { TEST_TASK_STATUS } from 'src/constants/testTask';

interface IMultipleTTLayoutProps {
  testTaskSelected: string | null;
  testTasks?: AvailableTestTaskWithPositionsData[];
  isPerformingAction: boolean;
  handleTTChange: (testTask: AvailableTestTaskWithPositionsData) => void;
  handlePassTTClick: () => void;
}

const MultipleTTLayout: React.FC<IMultipleTTLayoutProps> = ({
  testTaskSelected = '',
  testTasks,
  isPerformingAction,
  handleTTChange,
  handlePassTTClick,
}) => {
  const { isTTSelectionPageSimplified } = useFeatureFlags();

  const hasFailedTestTasks = testTasks?.some(
    (tt) => tt.status === TEST_TASK_STATUS.FAILED,
  );

  return (
    <>
      {!isTTSelectionPageSimplified && (
        <Typography
          variant="body1"
          mb={1}
          data-testid="tt-not-passed-yet-subtext"
        >
          Please select a language you prefer:
        </Typography>
      )}
      <TestTasksSelectableList
        selectedTestTask={testTaskSelected}
        testTasks={testTasks}
        handleChange={handleTTChange}
      />
      {hasFailedTestTasks && (
        <Typography
          variant="body2"
          color="secondary"
          mb={2}
          data-testid="failed-tt-notifier"
        >
          You have done it before with a low score,
          <br />
          you can proceed with other technologies.
        </Typography>
      )}
      <Stack spacing={3} direction="column" mt={4}>
        <Flex flexDirection="column" gap={4} alignItems="start">
          <PassTestTaskButton
            isDisabled={!testTaskSelected}
            isLoading={isPerformingAction}
            handlePassTTClick={handlePassTTClick}
          />
          {!isTTSelectionPageSimplified && <HackerRankDescription />}
        </Flex>
      </Stack>
    </>
  );
};

export default MultipleTTLayout;
